/* ==========================================================================
   Lumen — component-badges.js
   Ticks every product-card sale-countdown badge ([data-countdown] with a
   data-end epoch) once a second from one shared interval. Hides a badge when
   its sale has ended. Honest: the end time is rendered server-side from a real
   date (product metafield custom.sale_end, or the global fallback).
   ========================================================================== */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function format(sec) {
    var d = Math.floor(sec / 86400);
    var h = Math.floor((sec % 86400) / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var els = document.querySelectorAll('[data-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = parseInt(el.getAttribute('data-end'), 10) || 0;
      var rem = end - now;
      if (rem <= 0) { el.style.display = 'none'; continue; }
      var out = el.querySelector('[data-countdown-time]');
      if (out) out.textContent = format(rem);
    }
  }

  tick();
  window.setInterval(tick, 1000);
})();
